import * as React from "react";
import { useState, useRef, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Stack,
  Avatar,
  // Paper,
  Grid,
  // Button,
} from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { tableRowSx } from "services/constants";
import TablePagination from "@mui/material/TablePagination";
import { showToast } from "services/utils/Status";
import "react-toastify/dist/ReactToastify.css";
import { Loader } from "components/Loader";
import { useSelector } from "react-redux";
import "./style.css";
import { themes, scrollTop, optionalAvathar } from "services/constants";
import sessionHandling from "services/utils/notificationUtils";
import { leaveHistory } from "../Headers";
import { InfoMessage } from "components/CustomComponents/CustomButton";

const Approved = ({
  setReloadApprovedData,
  reloadApprovedData,
  userId,
  startDate,
  endDate,
}) => {
  const { domain, token, userDetails, globalSearchValue, topbarCompanyId } =
    useSelector((state) => state.tokenReducer);
  const [loading, setLoading] = useState(false);
  const { departmentId } = useSelector((state) => state.userReducer);
  const [expandedRow, setExpandedRow] = React.useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [masterDataForSearch, setMasterDataForSearch] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const containerRef = useRef(null);

  const handleRowClick = (rowId) => {
    if (expandedRow === rowId) {
      setExpandedRow(null);
    } else {
      setExpandedRow(rowId);
    }
  };

  useEffect(() => {
    if (topbarCompanyId) {
      setReloadApprovedData(true);
    }
  }, [setReloadApprovedData, topbarCompanyId]);

  useEffect(() => {
    const fetchApprovedData = async () => {
      setLoading(true);
      try {
        const apiUrl = `${domain}leave-request/?user_id=${userDetails.id}&approved_reject_status=Approved&department_id=${departmentId}&selected_user_id=${userId}&start_date=${startDate}&end_date=${endDate}&company_id=${topbarCompanyId}`;
        const response1 = await fetch(apiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        });

        const res1 = await response1.json();
        if (response1.ok) {
          const totalData = res1;
          totalData?.sort(
            (a, b) =>
              new Date(b?.from_date.split("-").reverse().join("-")) -
              new Date(a?.from_date.split("-").reverse().join("-"))
          );
          setMasterDataForSearch(totalData);
          setFilteredData(totalData);
        } else {
          if (!response1.ok) {
            if (response1.status === 409) {
              sessionHandling();
            } else {
              throw new Error(res1.error);
            }
          }
        }
      } catch (error) {
        showToast("error", error.message);
      } finally {
        setLoading(false);
      }
    };
    if (reloadApprovedData && startDate && endDate) {
      fetchApprovedData();
      setReloadApprovedData(false);
    }
  }, [
    token,
    userDetails.id,
    domain,
    userDetails.type,
    reloadApprovedData,
    setReloadApprovedData,
    departmentId,
    userId,
    startDate,
    endDate,
    topbarCompanyId,
  ]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const FilterDockets = () => {
      const cols =
        masterDataForSearch[0] && Object.keys(masterDataForSearch[0]);
      return masterDataForSearch.filter((r) =>
        cols.some((c) =>
          r[c]
            ? r[c]
                .toString()
                .toLowerCase()
                .indexOf(globalSearchValue.toString().toLowerCase()) > -1
            : null
        )
      );
    };
    setFilteredData(FilterDockets());
    setPage(globalSearchValue ? 0 : page);
  }, [globalSearchValue, masterDataForSearch, page]);

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  return loading ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      <Grid container>
        <TableContainer
          ref={containerRef}
          sx={{ width: "100%", maxHeight: 724, mt: 2, ml: 2, mr: 2 }}
        >
          <Table className="border">
            <TableHead
              sx={{
                backgroundColor: themes.primary,
                position: "sticky",
                top: -1,
                zIndex: 10,
              }}
            >
              <TableRow sx={tableRowSx}>
                {leaveHistory.map((header) => (
                  <TableCell
                    sx={{ color: themes.headLine, fontWeight: "bold" }}
                  >
                    {header.name}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredData?.length === 0 ? (
                <InfoMessage dataLength={masterDataForSearch} />
              ) : (
                filteredData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item) => (
                    <>
                      <TableRow sx={tableRowSx}>
                        {leaveHistory.map((header) => (
                          <TableCell sx={{ color: themes.headLine }}>
                            {header.key === "arrow" ? (
                              <>
                                {expandedRow === item.id ? (
                                  <IconButton
                                    onClick={() => {
                                      setExpandedRow(null);
                                    }}
                                  >
                                    <KeyboardArrowDownIcon
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                      }}
                                    />
                                  </IconButton>
                                ) : (
                                  <IconButton
                                    onClick={() => handleRowClick(item.id)}
                                  >
                                    <KeyboardArrowRightIcon
                                      style={{
                                        color: "black",
                                        fontWeight: "bold",
                                      }}
                                    />
                                  </IconButton>
                                )}
                              </>
                            ) : header.key === "username" ? (
                              <Stack direction="Row">
                                <Avatar
                                  sx={{ width: 23, height: 23 }}
                                  alt={item?.username?.charAt(0).toUpperCase()}
                                  src={item?.image_url ?? optionalAvathar}
                                />
                                &nbsp;
                                {item?.username}
                              </Stack>
                            ) : item[header.key] ? (
                              header.name === "Duration" ? (
                                <>
                                  {item.title === "Leave"
                                    ? item.business_days +
                                      `${
                                        item.business_days === 1
                                          ? "day"
                                          : "days"
                                      }`
                                    : item.total_time + " hr"}
                                </>
                              ) : (
                                item[header.key]
                              )
                            ) : (
                              "N/A"
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                      {expandedRow === item.id && (
                        <TableRow sx={tableRowSx}>
                          <TableCell colSpan={9}>
                            <TableContainer
                              sx={{
                                marginTop: 0.5,
                                marginLeft: "auto",
                                marginRight: "auto",
                                width: "100%px",
                              }}
                              className="w-96 border rounded"
                            >
                              <Table className="border">
                                <Typography
                                  variant="body1"
                                  gutterBottom
                                  sx={{ marginLeft: 1, marginTop: 0.5 }}
                                >
                                  <strong>Description :</strong>{" "}
                                  <Typography
                                    fontSize={15}
                                    color="textSecondary"
                                    sx={{ marginLeft: 13 }}
                                  >
                                    {item.description}
                                  </Typography>
                                </Typography>
                              </Table>
                            </TableContainer>
                            {item?.status === "Rejected" && (
                              <TableContainer
                                sx={{
                                  marginTop: 0.5,
                                  marginLeft: "auto",
                                  marginRight: "auto",
                                  width: "100%px",
                                }}
                                className="w-96 border rounded"
                              >
                                <Table className="border">
                                  <Typography
                                    variant="body1"
                                    gutterBottom
                                    sx={{ marginLeft: 1, marginTop: 0.5 }}
                                  >
                                    <strong>Reason for Rejection :</strong>{" "}
                                    <Typography
                                      fontSize={15}
                                      color="textSecondary"
                                      sx={{ marginLeft: 13 }}
                                    >
                                      {item.reason}
                                    </Typography>
                                  </Typography>
                                </Table>
                              </TableContainer>
                            )}
                            {item.title === "Leave" ? null : (
                              <TableContainer
                                sx={{
                                  marginTop: 0.5,
                                  marginLeft: "auto",
                                  marginRight: "auto",
                                  width: "100%px",
                                }}
                                className="w-96 border rounded"
                              >
                                <Table className="border">
                                  <Typography
                                    variant="body1"
                                    gutterBottom
                                    sx={{ marginLeft: 1, marginTop: 0.5 }}
                                  >
                                    <strong>
                                      Time Period :{" "}
                                      {item.start_time + " To " + item.end_time}
                                    </strong>
                                  </Typography>
                                </Table>
                              </TableContainer>
                            )}
                          </TableCell>
                        </TableRow>
                      )}
                    </>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>

      {filteredData.length > 25 && (
        <TablePagination
          className="custom-pagination"
          rowsPerPageOptions={[25, 50, 75, 100]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </React.Fragment>
  );
};

export default Approved;
